import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PrintComponents from "react-print-components";
import moment from "moment/moment";

import { getSpecificReturnDispatch } from "../../../actions/returnDispatchesActions";

import LogoBlue from "../../../assets/image/logo_blue.png";
import PrintIcon from "../../../assets/image/print.png";

import "../../DisposalBalances/NewIssue/NewIssue.scss";
import "./ReturnDispatchPrintButton.scss";

class ReturnDispatchPrintButton extends Component {
    state = {
        loading: false,
        products: null,
    };

    triggerRef = React.createRef();

    handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { dispatch, getSpecificReturnDispatch } = this.props;
        if (this.state.loading || !dispatch || !dispatch.id) return;

        this.setState({ loading: true });
        getSpecificReturnDispatch(dispatch.id).then((res) => {
            const payload = res && res.payload;
            const data = payload && payload.data;
            if (data) {
                this.setState({ loading: false, products: data.products || [] }, () => {
                    if (this.triggerRef.current) this.triggerRef.current.click();
                });
            } else {
                this.setState({ loading: false });
            }
        });
    };

    render() {
        const { dispatch } = this.props;
        const { products, loading } = this.state;

        const items = products || [];
        const total = items.reduce(
            (sum, p) => sum + (Number(p.unit_price) || 0) * (Number(p.amount) || 0),
            0
        );

        return (
            <Fragment>
                <button
                    type="button"
                    className="print_icon_btn"
                    onClick={this.handleClick}
                    disabled={loading}
                    title="Печать"
                >
                    <img src={PrintIcon} alt="print" />
                </button>
                <div className="print_trigger_hidden">
                    <PrintComponents
                        trigger={
                            <button ref={this.triggerRef} type="button">
                                print
                            </button>
                        }
                    >
                        <div className="print_goods">
                            <div className="print_goods__header">
                                <div className="print_goods__header--logo">
                                    <img src={LogoBlue} alt="Logo" />
                                </div>
                                <div className="print_goods__header--company">
                                    {dispatch && dispatch.supplier}
                                </div>
                            </div>
                            <div className="print_goods__date">
                                <span>
                                    {dispatch && dispatch.date
                                        ? moment(dispatch.date).format("DD.MM.YYYY HH:mm")
                                        : ""}
                                </span>
                            </div>
                            <div
                                className="print_goods__title"
                                style={{ textAlign: "center" }}
                            >
                                Возвратная накладная
                            </div>
                            <div className="new_issue_table">
                                <div className="table_container transactions_columns return_dispatch_repeat_print_table">
                                    <div className="table_header">
                                        <div className="table_row">
                                            <div className="row_item">Артикул</div>
                                            <div className="row_item">Производитель</div>
                                            <div className="row_item">К-во</div>
                                            <div className="row_item">Цена</div>
                                            <div className="row_item">Сумма</div>
                                        </div>
                                    </div>
                                    <div className="table_body">
                                        {items.map((product, idx) => {
                                            const price = Number(product.unit_price) || 0;
                                            const amount = Number(product.amount) || 0;
                                            return (
                                                <div className="table_row" key={idx}>
                                                    <div className="row_item">
                                                        {product.article_number}
                                                    </div>
                                                    <div className="row_item">
                                                        {product.producer ||
                                                            product.manufacturer ||
                                                            ""}
                                                    </div>
                                                    <div className="row_item">{amount}</div>
                                                    <div className="row_item">
                                                        {price.toFixed(2)}
                                                    </div>
                                                    <div className="row_item">
                                                        {(price * amount).toFixed(2)}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className="table_container__summary">
                                        Итого: {total.toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PrintComponents>
                </div>
            </Fragment>
        );
    }
}

const mapDispatchToProps = {
    getSpecificReturnDispatch,
};

export default connect(null, mapDispatchToProps)(ReturnDispatchPrintButton);
